import React, { useState } from 'react';
import classes from './MyAccordion.module.scss';
import { ChevronDownIcon } from '@chakra-ui/icons';

const MyAccordion = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const renderContent = (content) => {
    return (
      <div>
        {content.map((item, index) => 
        (
          <div key={index}>
            {Object.keys(item)[0] === "regularText" ? <p className={classes.regularTextStyle}>{item.regularText}</p> : null}
            {Object.keys(item)[0] === "boldText" ? <p className={classes.boldTextStyle}>{item.boldText}</p> : null}
            {Object.keys(item)[0] === "bullets" ?
              <ul className={classes.bulletsStyle}>
                {Object.keys(item)[0] === "bullets" ? item.bullets.map((bullet, i) => (
                  <li key={i}>{bullet}</li>
                )) : null}
              </ul>
            : null}
            {Object.keys(item)[0] === "special" ? 
            <div className={classes.specialDivStyle}>
                <div className={classes.leftDiv}><p>{item.special.left}</p></div>
                <div className={classes.rightDiv}><p>{item.special.right}</p></div>
            </div> : null}
            {Object.keys(item)[0] === "specialDays" ? 
            <div className={classes.specialDivStyle}>
                <div className={classes.leftDaysDiv}><p>{item.specialDays.left}</p></div>
                <div className={classes.rightDaysDiv}><p>{item.specialDays.right}</p></div>
            </div> : null}
          </div>
        )
      )
        }
      </div>
    );
  }

  return (
    <div className={classes.Accordion}>
      {items.map((item, index) => (
        <div key={index} className={classes.AccordionItem}>
          <div 
            className={classes.AccordionHeader}
            onClick={() => toggleAccordion(index)}
          >
            <div>
              <ChevronDownIcon
                className={`${classes.Icon} ${
                  activeIndex === index ? classes.ActiveIcon : ''
              }`}/>
            </div>

            <div>
              {item.title}
            </div>
          </div>
          
          <div
            className={`${classes.AccordionContent} ${
              activeIndex === index ? classes.active : ''
            }`}
          >
            {renderContent(item.content)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MyAccordion;
